// 缴费
<template>
  <div>


    <!-- 报名开始 -->
    <van-form @submit="onSignUpSubmit">


      <div data-v-40f4caea="" class="van-cell van-field">
        <div class="van-cell__title van-field__label">
          <span>缴费截图</span>
        </div>
        <div class="van-cell__value van-field__value">
          <div class="van-field__body">
            <van-uploader v-model="student.paymentList" :after-read="afterReadPayment" />
          </div>
        </div>
      </div>
      <div class="van-collapse-item__content">
        <div>请上传缴费截图</div>
      </div>



      <div style="margin: 16px;">
        <van-button round block type="primary" native-type="submit">
          提交
        </van-button>
      </div>
    </van-form>

    <div v-html="recruitStudent.paymentDescription" style="padding: 10px 10px 10px 10px;"></div>

    <!-- <div style="margin: 16px;">
          <van-button round block type="primary" @click="$router.push('detail')">
          
          </van-button>
      </div> -->
  </div>
</template>

<script>
import { getNotice, getDetail, saveStudent, uploadAttachment } from '@/api/index.js';
export default {
  data() {
    return {
      recruitStudent: {},
      student: {}
    };
  },
  mounted() {
    this.getNotice();
    this.getDetail();
  },
  methods: {
    onSignUpSubmit(values) {
      console.log('submit', values)
      let params = Object.assign({
        paymentIds: this.student.paymentList.map((att) => att.id).join(',')
      }, values);
      saveStudent(params).then(res => {
        if (res.data.success) {
          // this.$toast.success('您已报名成功，请注意查收通知短信，如有疑问联系招生办（15659981009）');
          this.$dialog.alert({
            message: '上传成功。'
          });
        } else {
          this.$toast.fail(res.data.message);
        }
      })
        .catch(error => {
          console.log(error)
        });

    },
    getDetail() {
      getDetail().then(res => {
        let stu = res.data.data;
        for (let att of stu.paymentList) {
          att.isImage = att.image
          att.url = 'system/attachment!send.action?id=' + att.id;
        }
        if (!stu.grade.enrollFaculty) {
          stu.grade.enrollFaculty = {}
        }
        this.student = stu
        this.$emit('updateTab', 'pay')
      })
        .catch(error => {
          console.log(error)
        });
    },
    getNotice() {
      getNotice().then(res => {
        this.recruitStudent = res.data.data
      })
        .catch(error => {
          console.log(error)
        });
    },
    afterReadPayment(file) {
      // 此时可以自行将文件上传至服务器
      console.log(file);
      file.status = 'uploading';
      uploadAttachment(file.file).then(({ data: res }) => {
        if (res.success) {
          file.status = 'done';
          file.id = res.id
        } else {
          throw new Error(res.message)
        }
      }).catch(error => {
        this.paymentList.splice(this.paymentList.indexOf(file), 1)
        console.error(error)
      })
    },
  }
}
</script>

<style scoped>
.van-collapse-item__content {
    padding: 12px 16px;
    color: #969799;
    font-size: 14px;
    line-height: 1.5;
    background-color: #fff;
}
</style>